<section id="hero">
    <swiper-container navigation="true" slides-per-view="1" space-between="0" (slideChange)="onSlideChange($event)">
        <swiper-slide *ngFor="let item of slides">
            @if ((viewport_is_mobile && item.mobile_video) || (!viewport_is_mobile && item.video)) {
            <div class="embed-responsive w-100" [ngClass]="{ 'mobile': viewport_is_mobile }" [ngStyle]="{
                  'background-image': viewport_is_mobile
                    ? 'url(' + item.mobile_poster + ')'
                    : 'url(' + item.poster + ')',
                  'background-size': 'cover',
                  'background-repeat': 'no-repeat'
                }">
                <video #mainVideo class="embed-responsive-item" autoplay muted loop playsinline
                    preload="metadata"></video>
            </div>
            }
            @if (item.image) {
            <img [src]="item.image" alt="image" class="img-fluid w-100" />
            }
            <div class="overlay d-flex flex-column justify-content-center align-items-center">
                <div *ngIf="item.html" class="d-flex flex-column justify-content-center align-items-center">
                    <div id="hero-content" class="d-flex flex-column justify-content-center align-items-center">
                        <h3 hidden class="compliance text-white text-center">BERRY/TAA COMPLIANT</h3>
                        <h1 class="full-uniform text-white text-center">BORN PRIMITIVE TACTICAL<br />FULL UNIFORM SET
                        </h1>
                        <button routerLink="/contact" style="max-width:435px" class="btn btn-secondary extended">CONTACT
                            FOR QUOTE</button>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</section>

<section id="shop" class="pb-3 pt-5">
    <div class="container">
        <div class="d-flex flex-row justify-content-between row">
            <div id="catalog" class="col">
                <h1>CATALOG</h1>
            </div>
            <div class="col d-flex flex-row justify-content-end">
                <div class="collection-toggle d-inline-flex flex-row justify-content-end" hidden>
                    <a tabindex="0" role="button" title="view TAA compliant items" (click)="collection='taa-display'"
                        [class.active]="collection === 'taa-display'">TAA</a>
                    <a tabindex="0" role="button" title="view BERRY compliant items"
                        (click)="collection='berry-display'" [class.active]="collection === 'berry-display'">BERRY</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="py-2">
    <div class="container">
        <app-product-list [handle]="collection"></app-product-list>
        <div class="row my-3">
            <div class="col">
                <button [routerLink]="['contact']" class="btn btn-primary extended">CONTACT FOR QUOTE</button>
            </div>
        </div>
    </div>
</section>

<section id="infographic" class="py-2">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <!-- <h2 class="text-center mt-5 made-in-usa">PROUDLY MADE IN THE USA</h2> -->
                <h2 class="text-center mt-5 made-in-usa">Proudly Servicing USA Made Fabrics</h2>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <div class="infographic w-100 ">
                <app-canvas-infographic></app-canvas-infographic>
            </div>
        </div>
    </div>
    <div class="container mb-5">
        <div class="row">
            <div class="col">
                <button [routerLink]="['contact']" class="btn btn-primary extended">CONTACT FOR QUOTE</button>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="d-flex d-md-none col-md-7 py-1 py-md-5 my-3">
                <!-- <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/how-to-img.png?v=1738880392"
                    alt="TAA & BERRY Compliant Apparel" class="img-fluid"> -->
                <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/BPT_PHX_FINAL-690.jpg?v=1793304231"
                    alt="TAA & BERRY Compliant Apparel" class="img-fluid">
            </div>
            <div class="align-content-center col-md-5 py-1 py-md-5 pe-5">
                <h1>HOW TO ORDER</h1>
                <p>
                    Please email us at <a href="mailto:Tactical@BornPrimitive.com">Tactical&#64;BornPrimitive.com</a> to
                    place your order with your desired item numbers and quantities.
                    <br>
                    <br>
                </p>
                <button [routerLink]="['contact']" class="btn btn-primary extended">CONTACT FOR QUOTE</button>
            </div>
            <div class="d-none d-md-flex col-md-7 py-1 py-md-5">
                <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/BPT_PHX_FINAL-690.jpg?v=1793304231"
                    alt="TAA & BERRY Compliant Apparel" class="img-fluid">
                <!-- <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/how-to-img.png?v=1738880392"
                    alt="TAA & BERRY Compliant Apparel" class="img-fluid"> -->
            </div>
        </div>
    </div>
</section>